import settingsActions, { SettingsActions } from 'actions/settingsActions';
import breadcrumbActions, { BreadcrumbActions } from './breadcrumbActions';
import broadcastActions, { BroadcastActions } from './broadcastActions';
import commentActions, { CommentActions } from './commentActions';
import disciplineActions, { DisciplineActions } from './disciplineActions';
import documentActions, { DocumentActions } from './documentActions';
import editingActions, { EditingActions } from './editingActions';
import eulaActions, { EulaActions } from './eulaActions';
import exportActions, { ExportActions } from './exportActions';
import focusedMarkupActions, {
  FocusedMarkupActions,
} from './focusedMarkupActions';
import geoLocationActions, { GeoLocationActions } from './geoLocationActions';
import groupActions, { GroupActions } from './groupActions';
import integrationActions, { IntegrationActions } from './integrationActions';
import interactionActions, { InteractionActions } from './interactionActions';
import licensingActions, { LicensingActions } from './licensingActions';
import linkActions, { LinkActions } from './linkActions';
import mappedSheetQueryActions, {
  MappedSheetQueryActions,
} from './mappedSheetQueryActions';
import mappedSheetActions, {
  MappedSheetActions,
} from './mappedSheetVersionActions';
import markupActions, { MarkupActions } from './markupActions';
import modalActions, { ModalActions } from './modalactions';
import pageActions, { PageActions } from './pageActions';
import pendoActions, { PendoActions } from './pendoActions';
import processingStatusActions, {
  ProcessingStatusActions,
} from './processingStatusActions';
import projectActions, { ProjectActions } from './projectActions';
import projectDriveActions, {
  ProjectDriveActions,
} from './projectDriveActions';
import publishRequestActions, {
  PublishRequestActions,
} from './publishRequestActions';
import punchActions, { PunchActions } from './punchActions';
import punchListActions, { PunchListActions } from './punchListActions';
import punchQueryActions, { PunchQueryActions } from './punchQueryActions';
import rfiActions, { RFIActions } from './rfiActions';
import rfiQueryActions, { RFIQueryActions } from './rfiQueryActions';
import roleActions, { RoleActions } from './roleActions';
import sheetActions, { SheetActions } from './sheetActions';
import sheetQueryActions, { SheetQueryActions } from './sheetQueryActions';
import spaceActions, { SpaceActions } from './spaceActions';
import studioActions, { StudioActions } from './studioActions';
import submittalActions, { SubmittalActions } from './submittalActions';
import submittalQueryActions, {
  SubmittalQueryActions,
} from './submittalQueryActions';
import uploadActions, { UploadActions } from './uploadActions';
import userActions, { UserActions } from './userActions';
import userProfileActions, { UserProfileActions } from './userProfileActions';
import userQueryActions, { UserQueryActions } from './userQueryActions';

export type AppActions = BreadcrumbActions &
  BroadcastActions &
  CommentActions &
  DisciplineActions &
  DocumentActions &
  EditingActions &
  EulaActions &
  ExportActions &
  FocusedMarkupActions &
  GeoLocationActions &
  GroupActions &
  IntegrationActions &
  InteractionActions &
  LicensingActions &
  LinkActions &
  MappedSheetActions &
  MappedSheetQueryActions &
  MarkupActions &
  ModalActions &
  PageActions &
  PendoActions &
  ProcessingStatusActions &
  ProjectActions &
  ProjectDriveActions &
  PublishRequestActions &
  PunchActions &
  PunchListActions &
  PunchQueryActions &
  RFIActions &
  RFIQueryActions &
  RoleActions &
  SettingsActions &
  SheetActions &
  SheetQueryActions &
  SpaceActions &
  StudioActions &
  SubmittalActions &
  SubmittalQueryActions &
  UploadActions &
  UserActions &
  UserProfileActions &
  UserQueryActions;

const appActions: AppActions = {
  ...groupActions,
  ...projectActions,
  ...licensingActions,
  ...userActions,
  ...punchActions,
  ...interactionActions,
  ...modalActions,
  ...punchListActions,
  ...disciplineActions,
  ...punchQueryActions,
  ...documentActions,
  ...pageActions,
  ...eulaActions,
  ...roleActions,
  ...userProfileActions,
  ...processingStatusActions,
  ...sheetActions,
  ...settingsActions,
  ...publishRequestActions,
  ...markupActions,
  ...spaceActions,
  ...linkActions,
  ...rfiActions,
  ...rfiQueryActions,
  ...sheetQueryActions,
  ...submittalActions,
  ...submittalQueryActions,
  ...focusedMarkupActions,
  ...uploadActions,
  ...editingActions,
  ...exportActions,
  ...pendoActions,
  ...userQueryActions,
  ...mappedSheetActions,
  ...mappedSheetQueryActions,
  ...integrationActions,
  ...studioActions,
  ...projectDriveActions,
  ...breadcrumbActions,
  ...broadcastActions,
  ...commentActions,
  ...geoLocationActions,
};

export default appActions;
